var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardMartiniGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1030,
    height: 1323,
    viewBox: "0 0 1030 1323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.11,
    clipPath: "url(#clip0_2925_20006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83887 8.83887L523.839 523.839",
    stroke: "white",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.16 8.83887L506.161 523.839",
    stroke: "white",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.5 515.678V1254.68",
    stroke: "white",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.5 1222.68L618.99 1297.68H412.01L515.5 1222.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.119 466.678L258 203.678H779L516.119 466.678Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2925_20006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1030,
    height: 1323,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMartiniGlass);
export default __webpack_public_path__ + "static/media/cardMartiniGlass.e6712c7ebcf4389850c8e6e36512299b.svg";
export { ForwardRef as ReactComponent };